import React, { useEffect, useState } from "react";
import {
    Grid,
    Select,
    InputBase,
    Checkbox,
    FormControlLabel
} from "@material-ui/core"
import useStyles from "./styles";
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "./../../../components/Message/Alert";
import Loader from './../../../components/Loader/Loader';
import { formatNumberComma } from '../../../../src/components/Common/Extensions';
import SearchGrid from '../../../components/table/SearchGrid';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import { PhoneOutlined, CloseCircleOutlined, ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

function VoiceCallLogs({ accessableRouts, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [isDataRefresh, setIsDataRefresh] = useState(false);
    const [filters, setFilters] = useState({ selectedDaysFilter: 'this_month', selectedStatus: '' });
    const [searchFilter, setValue] = useState('');
    const [callNotificationList, setcallNotificationList] = useState([]);
    const [statusCounts, setStatusCounts] = useState([]);
    const daysFilter = [
        {
            value: 'today',
            label: 'Today'
        },

        {
            value: 'this_week',
            label: 'Last 7 Days'
        },
        {
            value: 'this_month',
            label: 'Last 30 Days'
        },
        {
            value: 'last_6_months',
            label: 'Last 6 Months'
        },
        {
            value: 'last_12_months',
            label: 'Last 12 Months'
        }
    ]

    const CallStatusFilters = [
        { value: '', label: 'Total', icon: <PhoneOutlined />, className: 'total' },
        { value: 'ringing', label: 'Ringing', icon: <PhoneOutlined />, className: 'ringing' },
        { value: 'in-progress', label: 'In Progress', icon: <PhoneOutlined />, className: 'in-progress' },
        { value: 'completed', label: 'Completed', icon: <CheckCircleOutlined />, className: 'completed' },
        { value: 'busy', label: 'Busy', icon: <CloseCircleOutlined />, className: 'busy' },
        { value: 'no-answer', label: 'Missed', icon: <ClockCircleOutlined />, className: 'no-answer' },
        { value: 'failed', label: 'Failed', icon: <CloseCircleOutlined />, className: 'failed' }
    ];

    const handleDataRefresh = () => {
        setIsDataRefresh(!isDataRefresh);
    }
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataRefresh()
        }
    }
    const handleStatusClick = (status) => {

        const newStatus = filters.selectedStatus === status ? '' : status;

        setFilters(prev => ({
            ...prev,
            selectedStatus: newStatus
        }));

        loadGrid(filters.selectedDaysFilter, newStatus);
    };
    const handleClearInput = (name) => {
        setValue('');
        handleDataRefresh();
    };
    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFilters(prevState => ({
            ...prevState,
            [name]: value
        }))
        loadGrid(value, filters.selectedStatus)
    }
    const getStatusCount = (value) => {

        const c = statusCounts || {};

        switch (value) {
            case '':
                return c.totalCount || 0;
            case 'ringing':
                return c.ringingCount || 0;
            case 'in-progress':
                return c.inProgressCount || 0;
            case 'completed':
                return c.completedCount || 0;
            case 'busy':
                return c.busyCount || 0;
            case 'failed':
                return c.failedCount || 0;
            case 'no-answer':
                return c.noAnswerCount || 0;
            default:
                return 0;
        }
    };
    const loadGrid = (datefilter, statusFilter) => {
        setIsLoading(true);

        const param = [
            datefilter,
            statusFilter
        ];

        PostDataAPI("voicecall/loadGrid", param).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {

                setcallNotificationList(result.data.list || []);

                setStatusCounts(result.data.count || []);
                handleDataRefresh();
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        });
    };
    useEffect(() => {
        loadGrid(filters.selectedDaysFilter, filters.selectedStatus);
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Shipping & Tracking"} currentLink={"Voice Call Logs"}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid row className={classes.gridHeader}>
                <div className={classes.statusBoxContainer}>
                    {CallStatusFilters.map((item, i) => (
                        <FormControlLabel
                            key={i}
                            className={classes.checkBoxFormLabel}
                            control={
                                <Checkbox
                                    name="selectedStatus"
                                    color="primary"
                                    className={classes.checkBoxBtn}
                                    checked={filters.selectedStatus === item.value}
                                    onChange={() => handleStatusClick(item.value)}
                                />
                            }
                            label={
                                <div className={`${classes.statusCard} ${classes[item.className]}`}>
                                    <div className={classes.statusCardInner}>

                                        <div className={classes.statusIconWrap}>
                                            {item.icon}
                                        </div>

                                        <div className={classes.statusBoxContent}>
                                            <h5>{item.label}</h5>
                                            <h2>
                                                {formatNumberComma(getStatusCount(item.value))}
                                            </h2>
                                        </div>

                                    </div>
                                </div>
                            }
                        />
                    ))}
                </div>
            </Grid>

            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Select
                        size="small"
                        native
                        name="selectedDaysFilter"
                        value={filters.selectedDaysFilter}
                        onChange={handleSelectChange}
                        placeholder="Select"
                        label="Select"
                        className={classes.selectFilter}
                    >
                        {daysFilter.map(option =>
                            <option value={option.value}>{option.label}</option>
                        )
                        }
                    </Select>
                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        maxLength="2"
                    />
                </div>

            </Grid>
            <Grid row className={classes.container}>
                <SearchGrid
                    columns="VoiceCallGrid"
                    list={callNotificationList}
                    noRecordMsg="No Record Found"
                    isUpdate={isDataRefresh}
                    Icon={true}
                    isTopPagination={true}
                    filter={searchFilter}
                />
            </Grid>
        </>
    )
}
export default withSnackbar(VoiceCallLogs);